'use strict';
import {SystemEvent} from "../../services/system-state/SystemEvent";

{
    var app = angular.module('tf.portfolio.widgets.deltaChart', [])
        .controller('deltaChartCtrl', ['$scope', '$filter', '$localStorage', '$timeout', 'userConfig', "systemEventService",
            function ($scope, $filter, $localStorage, $timeout, userConfig, systemEventService) {
            var percentFilter = $filter('percentage');
            var numberFilter = d3.format('$,.0f');

            $scope.widgetContentHeight = 280;

            var defaultStorage = {
                greeksWidget : {
                    includeEquities : false,
                    chartType : 'netDelta'
                }
            };

            $scope.$storage = $localStorage.$default(defaultStorage);

            var whatIfMargin = null;

            $scope.chart = {
                security : null,
                activeChart : null,
                includeEquities : $scope.$storage.greeksWidget.includeEquities
            };

            var netDeltaChart = {
                type : 'netDelta',
                label : 'Net Delta ($)',
                yAxisLabel : 'Delta Value',
                data : function() {
                    function byNetDelta(a, b) {
                        if (a.netDelta < b.netDelta)
                            return -1;
                        if (a.netDelta > b.netDelta)
                            return 1;
                        return 0;
                    }

                    var netDeltaShort = [];
                    var netDeltaLong = [];

                    if (whatIfMargin) {
                        if ($scope.chart.security) {


                            whatIfMargin.positions.sort(byNetDelta);

                            for (var i = 0; i < whatIfMargin.positions.length; i++) {
                                var position = whatIfMargin.positions[i];
                                if ($scope.chart.security === position.security) {
                                    netDeltaShort.push([position.code, Math.min(0, position.netDelta)]);
                                    netDeltaLong.push([position.code, Math.max(0, position.netDelta)]);
                                }
                            }

                            if ($scope.$storage.greeksWidget.includeEquities) {
                                whatIfMargin.equityCollateral.forEach(function (equityCollateral) {
                                    if ($scope.chart.security === equityCollateral.issuer) {
                                        var netDelta = equityCollateral.quantity;
                                        whatIfMargin.unlodgedCollateral.forEach(function (unlodged) {
                                            if (equityCollateral.issuer === unlodged.securityCode) {
                                                netDelta += unlodged.quantity;
                                            }

                                        });
                                        netDeltaShort.push([equityCollateral.issuer, 0]);
                                        netDeltaLong.push([equityCollateral.issuer, netDelta]);
                                    }
                                });
                                whatIfMargin.unlodgedCollateral.forEach(function (equityCollateral) {
                                    if ($scope.chart.security === equityCollateral.securityCode) {
                                        var hasCollateralEntry = whatIfMargin.equityCollateral.some(function(entry){
                                            return entry.issuer === equityCollateral.securityCode;
                                        });
                                        if (!hasCollateralEntry) {
                                            netDeltaShort.push([equityCollateral.securityCode, 0]);
                                            netDeltaLong.push([equityCollateral.securityCode, equityCollateral.quantity]);
                                        }
                                    }
                                });
                            }
                        } else {
                            whatIfMargin.combinedCommodities.sort(byNetDelta);

                            for (var i = 0; i < whatIfMargin.combinedCommodities.length; i++) {
                                var cc = whatIfMargin.combinedCommodities[i];
                                var netDelta = cc.netDelta;

                                if ($scope.$storage.greeksWidget.includeEquities) {
                                    whatIfMargin.equityCollateral.forEach(function(equityCollateral) {
                                        if (equityCollateral.issuer === cc.security) {
                                            netDelta += equityCollateral.quantity;
                                        }
                                    });
                                    whatIfMargin.unlodgedCollateral.forEach(function(equityCollateral) {
                                        if (equityCollateral.securityCode === cc.security) {
                                            netDelta += equityCollateral.quantity;
                                        }
                                    });
                                }
                                netDeltaShort.push([cc.security, Math.min(0, netDelta), cc.security]);
                                netDeltaLong.push([cc.security, Math.max(0, netDelta), cc.security]);
                            }

                            if ($scope.$storage.greeksWidget.includeEquities) {
                                whatIfMargin.equityCollateral.forEach(function (equityCollateral) {

                                    var hasEntry = whatIfMargin.combinedCommodities.some(function(entry) {
                                        return entry.security === equityCollateral.issuer;
                                    });
                                    if (!hasEntry) {
                                        var netDelta = equityCollateral.quantity;
                                        whatIfMargin.unlodgedCollateral.forEach(function(unlodged) {
                                            if (unlodged.securityCode === equityCollateral.issuer) {
                                                netDelta += unlodged.quantity;
                                            }
                                        });
                                        netDeltaShort.push([equityCollateral.issuer, 0, equityCollateral.issuer]);
                                        netDeltaLong.push([equityCollateral.issuer, netDelta, equityCollateral.issuer]);
                                    }
                                });
                                whatIfMargin.unlodgedCollateral.forEach(function (equityCollateral) {

                                    var hasCCEntry = whatIfMargin.combinedCommodities.some(function(entry) {
                                        return entry.security === equityCollateral.securityCode;
                                    });
                                    var hasCollateralEntry = whatIfMargin.equityCollateral.some(function(entry){
                                        return entry.issuer === equityCollateral.securityCode;
                                    });
                                    if (!hasCCEntry && !hasCollateralEntry) {
                                        netDeltaShort.push([equityCollateral.securityCode, 0, equityCollateral.securityCode]);
                                        netDeltaLong.push([equityCollateral.securityCode, equityCollateral.quantity, equityCollateral.securityCode]);
                                    }
                                });
                            }
                        }
                    }

                    var chartData = [];
                    chartData.push({
                        key: 'Net Delta Long',
                        color: 'rgb(31, 119, 180)',
                        values: netDeltaLong
                    });

                    chartData.push({
                        key: 'Net Delta Short',
                        color: 'rgb(214, 39, 40)',
                        values: netDeltaShort
                    });

                    return chartData;
                },
                tickFormat : function(v) {
                    return d3.format(',.0f')(v);
                },
                tooltip : function(e) {
                    var tooltip = '<h3>Net Delta ' + e.data[0] + '</h3>';
                    tooltip += '<table width="100%"><tbody>';
                    tooltip += '<tr><td class=\"key\">' + (e.data.series === 0 ? 'Long' : 'Short') + ' Shares</td> <td class="value">' + netDeltaChart.tickFormat(e.data[1]) + '</td><td></td></td></tr>';
                    tooltip += '</tbody></table>';


                    return tooltip;
                }
            };

            var weightedDeltaChart = {
                type : 'weightedDelta',
                label : 'Weighted Delta',
                yAxisLabel : 'Delta Value',
                data : function() {
                    function byTotalWeightedDelta(a, b) {
                        var totalDeltaA = a.weightedDeltaAvailable + a.weightedDeltaUsed;
                        var totalDeltaB = b.weightedDeltaAvailable + b.weightedDeltaUsed;

                        if (totalDeltaA < totalDeltaB)
                            return -1;
                        if (totalDeltaA > totalDeltaB)
                            return 1;
                        return 0;
                    }

                    var usedDelta = [];
                    var availableDelta = [];

                    if (whatIfMargin) {

                        whatIfMargin.combinedCommodities.sort(byTotalWeightedDelta);

                        for (var i = 0; i < whatIfMargin.combinedCommodities.length; i++) {
                            var cc = whatIfMargin.combinedCommodities[i];

                            usedDelta.push([cc.security, cc.weightedDeltaUsed]);
                            availableDelta.push([cc.security, cc.weightedDeltaAvailable]);

                        }
                    }


                    var chartData = [];
                    chartData.push({
                        key: 'Used Offset',
                        color: 'rgb(31, 119, 180)',
                        values: usedDelta
                    });

                    chartData.push({
                        key: 'Available Offset',
                        color: 'rgb(214, 39, 40)',
                        values: availableDelta
                    });

                    return chartData;
                },
                tickFormat : function(v) {
                    return d3.format(',.0f')(v);
                },
                tooltip : function(e) {
                    var used =  $scope.chartData[0].values[e.index][1];
                    var available = $scope.chartData[1].values[e.index][1];
                    var total = used + available;


                    var usedPercent = 0;
                    if (used !== 0) {
                        usedPercent = Math.abs(used) / Math.abs(total);
                    }

                    var availablePercent = 1 - usedPercent;

                    var tooltip = '<h3>Weighted Delta ' + e.data[0] + '</h3>';
                    tooltip += '<table width="100%"><tbody>';
                    tooltip += '<tr><td class=\"key\">Total</td> <td class="value">' + numberFilter(total) + '</td><td></td></td></tr>';
                    tooltip += '<tr><td class=\"key\">Used</td> <td class="value">' + numberFilter(used) + '</td><td>(' + percentFilter(usedPercent, 0) + ')</td></tr>';
                    tooltip += '<tr><td class=\"key\">Available</td> <td class="value">' + numberFilter(available) + '</td><td>(' + percentFilter(availablePercent, 0) + ')</td></tr>';
                    tooltip += '</tbody></table>';


                    return tooltip;
                }
            };

            var netDeltaPercentChart = {
                type : 'netDeltaPercent',
                label : 'Net Delta (%)',
                yAxisLabel : 'Delta Value',
                data : function() {

                    function byNetDeltaPercent(a, b) {
                        if (a.netDeltaPercent < b.netDeltaPercent)
                            return -1;
                        if (a.netDeltaPercent > b.netDeltaPercent)
                            return 1;
                        return 0;
                    }


                    var netDeltaPercentShort = [];
                    var netDeltaPercentLong = [];

                    if (whatIfMargin) {
                        whatIfMargin.positions.sort(byNetDeltaPercent);

                        if ($scope.chart.security) {

                            for (var i = 0; i < whatIfMargin.positions.length; i++) {
                                var position = whatIfMargin.positions[i];
                                if ($scope.chart.security === position.security) {
                                    netDeltaPercentShort.push([position.code, Math.min(0, position.netDeltaPercent)]);
                                    netDeltaPercentLong.push([position.code, Math.max(0, position.netDeltaPercent)]);
                                }

                            }

                            if ($scope.$storage.greeksWidget.includeEquities) {
                                whatIfMargin.equityCollateral.forEach(function (equityCollateral) {
                                    if ($scope.chart.security === equityCollateral.issuer) {
                                        var netDeltaPercent = equityCollateral.quantity * 0.01 * equityCollateral.price;
                                        whatIfMargin.unlodgedCollateral.forEach(function (unlodged) {
                                            if (equityCollateral.issuer === unlodged.securityCode) {
                                                netDeltaPercent += unlodged.quantity * 0.01 * unlodged.price;
                                            }

                                        });
                                        netDeltaPercentShort.push([equityCollateral.issuer, 0]);
                                        netDeltaPercentLong.push([equityCollateral.issuer, netDeltaPercent]);
                                    }
                                });
                                whatIfMargin.unlodgedCollateral.forEach(function (equityCollateral) {
                                    if ($scope.chart.security === equityCollateral.securityCode) {
                                        var hasCollateralEntry = whatIfMargin.equityCollateral.some(function(entry){
                                            return entry.issuer === equityCollateral.securityCode;
                                        });
                                        if (!hasCollateralEntry) {
                                            netDeltaPercentShort.push([equityCollateral.securityCode, 0]);
                                            netDeltaPercentLong.push([equityCollateral.securityCode, equityCollateral.quantity * 0.01 * equityCollateral.price]);
                                        }
                                    }
                                });
                            }

                        } else {

                            whatIfMargin.combinedCommodities.sort(byNetDeltaPercent);

                            for (var i = 0; i < whatIfMargin.combinedCommodities.length; i++) {
                                var cc = whatIfMargin.combinedCommodities[i];
                                var netDeltaPercent = cc.netDeltaPercent;

                                if ($scope.$storage.greeksWidget.includeEquities) {
                                    whatIfMargin.equityCollateral.forEach(function(equityCollateral) {
                                        if (equityCollateral.issuer === cc.security) {
                                            netDeltaPercent += equityCollateral.quantity * 0.01 * equityCollateral.price;
                                        }
                                    });
                                    whatIfMargin.unlodgedCollateral.forEach(function(equityCollateral) {
                                        if (equityCollateral.securityCode === cc.security) {
                                            netDeltaPercent += equityCollateral.quantity * 0.01 * equityCollateral.price;
                                        }
                                    });
                                }
                                netDeltaPercentShort.push([cc.security, Math.min(0, netDeltaPercent), cc.security]);
                                netDeltaPercentLong.push([cc.security, Math.max(0, netDeltaPercent), cc.security]);
                            }

                            if ($scope.$storage.greeksWidget.includeEquities) {
                                whatIfMargin.equityCollateral.forEach(function (equityCollateral) {
                                    var hasEntry = whatIfMargin.combinedCommodities.some(function(entry) {
                                        return entry.security === equityCollateral.issuer;
                                    });
                                    if (!hasEntry) {
                                        var netDeltaPercent = equityCollateral.quantity * 0.01 * equityCollateral.price;
                                        whatIfMargin.unlodgedCollateral.forEach(function(unlodged) {
                                            if (unlodged.securityCode === equityCollateral.issuer) {
                                                netDeltaPercent += unlodged.quantity * 0.01 * unlodged.price;
                                            }
                                        });
                                        netDeltaPercentShort.push([equityCollateral.issuer, 0, equityCollateral.issuer]);
                                        netDeltaPercentLong.push([equityCollateral.issuer, netDeltaPercent, equityCollateral.issuer]);
                                    }
                                });
                                whatIfMargin.unlodgedCollateral.forEach(function (equityCollateral) {
                                    var hasCCEntry = whatIfMargin.combinedCommodities.some(function(entry) {
                                        return entry.security === equityCollateral.securityCode;
                                    });
                                    var hasCollateralEntry = whatIfMargin.equityCollateral.some(function(entry){
                                        return entry.issuer === equityCollateral.securityCode;
                                    });
                                    if (!hasCCEntry && !hasCollateralEntry) {
                                        netDeltaPercentShort.push([equityCollateral.securityCode, 0, equityCollateral.securityCode]);
                                        netDeltaPercentLong.push([equityCollateral.securityCode, equityCollateral.quantity * 0.01 * equityCollateral.price, equityCollateral.securityCode]);
                                    }
                                });
                            }
                        }
                    }


                    var chartData = [];
                    chartData.push({
                        key: 'Net Delta (%) Long',
                        color: 'rgb(31, 119, 180)',
                        values: netDeltaPercentLong
                    });

                    chartData.push({
                        key: 'Net Delta (%) Short',
                        color: 'rgb(214, 39, 40)',
                        values: netDeltaPercentShort
                    });

                    return chartData;
                },
                tickFormat : function(v) {
                    return d3.format(',.0f')(v);
                },
                tooltip : function(e) {
                    var tooltip = '<h3>Net Delta (%) ' + e.data[0] + '</h3>';
                    tooltip += '<table width="100%"><tbody>';
                    tooltip += '<tr><td class=\"key\">' + ('Change on 1% move') + '</td> <td class="value">' + netDeltaPercentChart.tickFormat(e.data[1]) + '</td><td></td></td></tr>';
                    tooltip += '</tbody></table>';


                    return tooltip;
                }
            };

            var dollarDeltaChart = {
                type : 'dollarDelta',
                label : 'Dollar Delta',
                yAxisLabel : 'Delta Value',
                data : function() {

                    function byDollarDelta(a, b) {
                        if (a.dollarDelta < b.dollarDelta)
                            return -1;
                        if (a.dollarDelta > b.dollarDelta)
                            return 1;
                        return 0;
                    }


                    var dollarDeltaShort = [];
                    var dollarDeltaLong = [];

                    if (whatIfMargin) {

                        if ($scope.chart.security) {

                            whatIfMargin.positions.sort(byDollarDelta);

                            for (var i = 0; i < whatIfMargin.positions.length; i++) {
                                var position = whatIfMargin.positions[i];
                                if ($scope.chart.security === position.security) {

                                    var dollarDelta = position.dollarDelta;

                                    dollarDeltaShort.push([position.code, Math.min(0, dollarDelta)]);
                                    dollarDeltaLong.push([position.code, Math.max(0, dollarDelta)])
                                }
                            }

                            if ($scope.$storage.greeksWidget.includeEquities) {
                                whatIfMargin.equityCollateral.forEach(function (equityCollateral) {
                                    if ($scope.chart.security === equityCollateral.issuer) {
                                        var dollarDelta = equityCollateral.quantity * equityCollateral.price;
                                        whatIfMargin.unlodgedCollateral.forEach(function (unlodged) {
                                            if (equityCollateral.issuer === unlodged.securityCode) {
                                                dollarDelta += unlodged.quantity * unlodged.price;
                                            }

                                        });
                                        dollarDeltaShort.push([equityCollateral.issuer, 0]);
                                        dollarDeltaLong.push([equityCollateral.issuer, dollarDelta]);
                                    }
                                });
                                whatIfMargin.unlodgedCollateral.forEach(function (equityCollateral) {
                                    if ($scope.chart.security === equityCollateral.securityCode) {
                                        var hasCollateralEntry = whatIfMargin.equityCollateral.some(function(entry){
                                            return entry.issuer === equityCollateral.securityCode;
                                        });
                                        if (!hasCollateralEntry) {
                                            dollarDeltaShort.push([equityCollateral.securityCode, 0]);
                                            dollarDeltaLong.push([equityCollateral.securityCode, equityCollateral.quantity * equityCollateral.price]);
                                        }
                                    }
                                });
                            }

                        } else {

                            whatIfMargin.combinedCommodities.sort(byDollarDelta);

                            var totalDollarDelta = 0;

                            for (var i = 0; i < whatIfMargin.combinedCommodities.length; i++) {
                                var cc = whatIfMargin.combinedCommodities[i];

                                var dollarDelta = cc.dollarDelta;
                                totalDollarDelta += cc.dollarDelta;

                                if ($scope.$storage.greeksWidget.includeEquities) {
                                    whatIfMargin.equityCollateral.forEach(function(equityCollateral) {
                                        if (equityCollateral.issuer === cc.security) {
                                            dollarDelta += equityCollateral.quantity * equityCollateral.price;
                                            totalDollarDelta += equityCollateral.quantity * equityCollateral.price;
                                        }
                                    });
                                    whatIfMargin.unlodgedCollateral.forEach(function(equityCollateral) {
                                        if (equityCollateral.securityCode === cc.security) {
                                            dollarDelta += equityCollateral.quantity * equityCollateral.price;
                                            totalDollarDelta += equityCollateral.quantity * equityCollateral.price;
                                        }
                                    });
                                }
                                dollarDeltaShort.push([cc.security, Math.min(0, dollarDelta), cc.security]);
                                dollarDeltaLong.push([cc.security, Math.max(0, dollarDelta), cc.security]);
                            }

                            if ($scope.$storage.greeksWidget.includeEquities) {
                                whatIfMargin.equityCollateral.forEach(function (equityCollateral) {

                                    var hasEntry = whatIfMargin.combinedCommodities.some(function(entry) {
                                        return entry.security === equityCollateral.issuer;
                                    });
                                    if (!hasEntry) {
                                        var dollarDelta = equityCollateral.quantity * equityCollateral.price;
                                        whatIfMargin.unlodgedCollateral.forEach(function(unlodged) {
                                            if (unlodged.securityCode === equityCollateral.issuer) {
                                                dollarDelta += unlodged.quantity * unlodged.price;
                                            }
                                        });
                                        dollarDeltaShort.push([equityCollateral.issuer, 0, equityCollateral.issuer]);
                                        dollarDeltaLong.push([equityCollateral.issuer, dollarDelta, equityCollateral.issuer]);
                                    }
                                });
                                whatIfMargin.unlodgedCollateral.forEach(function (equityCollateral) {
                                    var hasCCEntry = whatIfMargin.combinedCommodities.some(function(entry) {
                                        return entry.security === equityCollateral.securityCode;
                                    });
                                    var hasCollateralEntry = whatIfMargin.equityCollateral.some(function(entry){
                                        return entry.issuer === equityCollateral.securityCode;
                                    });
                                    if (!hasCCEntry && !hasCollateralEntry) {
                                        dollarDeltaShort.push([equityCollateral.securityCode, 0, equityCollateral.securityCode]);
                                        dollarDeltaLong.push([equityCollateral.securityCode, equityCollateral.quantity * equityCollateral.price, equityCollateral.securityCode]);
                                    }
                                });
                            }

                            if (totalDollarDelta) {
                                dollarDeltaShort.push(['Total', Math.min(0, totalDollarDelta)]);
                                dollarDeltaLong.push(['Total', Math.max(0, totalDollarDelta)]);
                            }
                        }
                    }

                    var chartData = [];
                    chartData.push({
                        key: 'Dollar Delta Long',
                        color: 'rgb(31, 119, 180)',
                        values: dollarDeltaLong
                    });

                    chartData.push({
                        key: 'Dollar Delta Short',
                        color: 'rgb(214, 39, 40)',
                        values: dollarDeltaShort
                    });

                    return chartData;

                },
                tickFormat : function(v) {
                    return d3.format('$,.0f')(v);
                },
                tooltip : function(e) {
                    var tooltip = '<h3>Dollar Delta ' + e.data[0] + '</h3>';
                    tooltip += '<table width="100%"><tbody>';
                    tooltip += '<tr><td class=\"key\">Face Value</td> <td class="value">' + dollarDeltaChart.tickFormat(e.data[1]) + '</td><td></td></td></tr>';
                    tooltip += '</tbody></table>';

                    return tooltip;
                }
            };

            var netGammaChart = {
                type : 'netGamma',
                label : 'Net Gamma',
                yAxisLabel : 'Gamma Value',
                data : function() {

                    function byNetGamma(a, b) {
                        if (a.netGamma < b.netGamma)
                            return -1;
                        if (a.netGamma > b.netGamma)
                            return 1;
                        return 0;
                    }

                    var netGammaShort = [];
                    var netGammaLong = [];

                    if (whatIfMargin) {

                        if ($scope.chart.security) {
                            whatIfMargin.positions.sort(byNetGamma);

                            for (var i = 0; i < whatIfMargin.positions.length; i++) {
                                var position = whatIfMargin.positions[i];
                                if ($scope.chart.security === position.security) {
                                    netGammaShort.push([position.code, Math.min(0, position.netGamma)]);
                                    netGammaLong.push([position.code, Math.max(0, position.netGamma)]);
                                }
                            }
                        } else {

                            whatIfMargin.combinedCommodities.sort(byNetGamma);

                            for (var i = 0; i < whatIfMargin.combinedCommodities.length; i++) {
                                var cc = whatIfMargin.combinedCommodities[i];

                                netGammaShort.push([cc.security, Math.min(0, cc.netGamma), cc.security]);
                                netGammaLong.push([cc.security, Math.max(0, cc.netGamma), cc.security]);
                            }
                        }
                    }

                    var chartData = [];
                    chartData.push({
                        key: 'Net Gamma Long',
                        color: 'rgb(31, 119, 180)',
                        values: netGammaLong
                    });

                    chartData.push({
                        key: 'Net Gamma Short',
                        color: 'rgb(214, 39, 40)',
                        values: netGammaShort
                    });

                    return chartData;

                },
                tickFormat : function(v) {
                    return d3.format('$,.0f')(v);
                },
                tooltip : function(e) {
                    var tooltip = '<h3>Net Gamma ' + e.data[0] + '</h3>';
                    tooltip += '<table width="100%"><tbody>';
                    tooltip += '<tr><td class=\"key\">' + (e.data.series === 0 ? 'Long' : 'Short') + ' Shares</td> <td class="value">' + netGammaChart.tickFormat(e.data[1]) + '</td><td></td></td></tr>';
                    tooltip += '</tbody></table>';


                    return tooltip;
                }
            };

            var netVegaChart = {
                type : 'netVega',
                label : 'Net Vega',
                yAxisLabel : 'Vega Value',
                data : function() {

                    function byNetVega(a, b) {
                        if (a.netVega < b.netVega)
                            return -1;
                        if (a.netVega > b.netVega)
                            return 1;
                        return 0;
                    }

                    var netVegaShort = [];
                    var netVegaLong = [];

                    if (whatIfMargin) {

                        if ($scope.chart.security) {
                            whatIfMargin.positions.sort(byNetVega);

                            for (var i = 0; i < whatIfMargin.positions.length; i++) {
                                var position = whatIfMargin.positions[i];
                                if ($scope.chart.security === position.security) {
                                    netVegaShort.push([position.code, Math.min(0, position.netVega)]);
                                    netVegaLong.push([position.code, Math.max(0, position.netVega)]);
                                }
                            }
                        } else {

                            whatIfMargin.combinedCommodities.sort(byNetVega);

                            for (var i = 0; i < whatIfMargin.combinedCommodities.length; i++) {
                                var cc = whatIfMargin.combinedCommodities[i];

                                netVegaShort.push([cc.security, Math.min(0, cc.netVega), cc.security]);
                                netVegaLong.push([cc.security, Math.max(0, cc.netVega), cc.security]);
                            }
                        }
                    }

                    var chartData = [];
                    chartData.push({
                        key: 'Net Vega Long',
                        color: 'rgb(31, 119, 180)',
                        values: netVegaLong
                    });

                    chartData.push({
                        key: 'Net Vega Short',
                        color: 'rgb(214, 39, 40)',
                        values: netVegaShort
                    });

                    return chartData;

                },
                tickFormat : function(v) {
                    return d3.format('$,.0f')(v);
                },
                tooltip : function(e) {
                    var tooltip = '<h3>Net Vega ' + e.data[0] + '</h3>';
                    tooltip += '<table width="100%"><tbody>';
                    tooltip += '<tr><td class=\"key\">' + ('Change on 1% move') + '</td> <td class="value">' + netVegaChart.tickFormat(e.data[1]) + '</td><td></td></td></tr>';
                    tooltip += '</tbody></table>';


                    return tooltip;
                }
            };

            var netThetaChart = {
                type : 'netTheta',
                label : 'Net Theta',
                yAxisLabel : 'Theta Value',
                data : function() {

                    function byNetTheta(a, b) {
                        if (a.netTheta < b.netTheta)
                            return -1;
                        if (a.netTheta > b.netTheta)
                            return 1;
                        return 0;
                    }

                    var netThetaShort = [];
                    var netThetaLong = [];

                    if (whatIfMargin) {

                        if ($scope.chart.security) {


                            whatIfMargin.positions.sort(byNetTheta);

                            for (var i = 0; i < whatIfMargin.positions.length; i++) {
                                var position = whatIfMargin.positions[i];
                                if ($scope.chart.security === position.security) {
                                    netThetaShort.push([position.code, Math.min(0, position.netTheta)]);
                                    netThetaLong.push([position.code, Math.max(0, position.netTheta)]);
                                }
                            }

                        } else {
                            whatIfMargin.combinedCommodities.sort(byNetTheta);

                            for (var i = 0; i < whatIfMargin.combinedCommodities.length; i++) {
                                var cc = whatIfMargin.combinedCommodities[i];

                                netThetaShort.push([cc.security, Math.min(0, cc.netTheta), cc.security]);
                                netThetaLong.push([cc.security, Math.max(0, cc.netTheta), cc.security]);
                            }
                        }
                    }

                    var chartData = [];
                    chartData.push({
                        key: 'Net Theta Long',
                        color: 'rgb(31, 119, 180)',
                        values: netThetaLong
                    });

                    chartData.push({
                        key: 'Net Theta Short',
                        color: 'rgb(214, 39, 40)',
                        values: netThetaShort
                    });

                    return chartData;

                },
                tickFormat : function(v) {
                    return d3.format('$,.0f')(v);
                },
                tooltip : function(e) {
                    var tooltip = '<h3>Net Theta ' + e.data[0] + '</h3>';
                    tooltip += '<table width="100%"><tbody>';
                    tooltip += '<tr><td class=\"key\">' + ('Time decay per day') + '</td> <td class="value">' + netThetaChart.tickFormat(e.data[1]) + '</td><td></td></td></tr>';
                    tooltip += '</tbody></table>';

                    return tooltip;
                }
            };

            var netRhoChart = {
                type : 'netRho',
                label : 'Net Rho',
                yAxisLabel : 'Rho Value',
                data : function() {

                    function byNetRho(a, b) {
                        if (a.netRho < b.netRho)
                            return -1;
                        if (a.netRho > b.netRho)
                            return 1;
                        return 0;
                    }

                    var netRhoShort = [];
                    var netRhoLong = [];

                    if (whatIfMargin) {

                        if ($scope.chart.security) {
                            whatIfMargin.positions.sort(byNetRho);

                            for (var i = 0; i < whatIfMargin.positions.length; i++) {
                                var position = whatIfMargin.positions[i];
                                if ($scope.chart.security === position.security) {
                                    netRhoShort.push([position.code, Math.min(0, position.netRho)]);
                                    netRhoLong.push([position.code, Math.max(0, position.netRho)])
                                }

                            }
                        } else {
                            whatIfMargin.combinedCommodities.sort(byNetRho);

                            for (var i = 0; i < whatIfMargin.combinedCommodities.length; i++) {
                                var cc = whatIfMargin.combinedCommodities[i];

                                netRhoShort.push([cc.security, Math.min(0, cc.netRho), cc.security]);
                                netRhoLong.push([cc.security, Math.max(0, cc.netRho), cc.security]);
                            }
                        }
                    }

                    var chartData = [];
                    chartData.push({
                        key: 'Net Rho Long',
                        color: 'rgb(31, 119, 180)',
                        values: netRhoLong
                    });

                    chartData.push({
                        key: 'Net Rho Short',
                        color: 'rgb(214, 39, 40)',
                        values: netRhoShort
                    });

                    return chartData;

                },
                tickFormat : function(v) {
                    return d3.format('$,.0f')(v);
                },
                tooltip : function(e) {
                    var tooltip = '<h3>Net Rho ' + e.data[0] + '</h3>';
                    tooltip += '<table width="100%"><tbody>';
                    tooltip += '<tr><td class=\"key\">' + ('Change on 1% move') + '</td> <td class="value">' + netRhoChart.tickFormat(e.data[1]) + '</td><td></td></td></tr>';
                    tooltip += '</tbody></table>';

                    return tooltip;
                }
            };

            var charts = [
                weightedDeltaChart,
                netDeltaChart,
                netDeltaPercentChart,
                dollarDeltaChart,
                netGammaChart,
                netVegaChart,
                netThetaChart,
                netRhoChart
            ];

            var chartMap = {};

            charts.forEach(function(e) {
                chartMap[e.type] = e;
            });
            $scope.charts = charts;

            $scope.setActiveChart = function(c) {
                $scope.chart.activeChart = c;
                $scope.chart.security = null;
                $scope.$storage.greeksWidget.chartType = c.type;
                $scope.updateChart();
            };

            var chartApi = null;

            $scope.deltaChartReady = function(scope, elem) {
                chartApi = scope.api;
            };

            $scope.updateChart = function() {
                $scope.chartOptions = createChartOptions($scope.chart.activeChart);
                $scope.redrawChart();
                if (chartApi != null) {
                    chartApi.refresh();
                }
            };

            const resizeSub = systemEventService.filter(evt => evt === SystemEvent.VIEW_RESIZE)
                                                .subscribe(() => $scope.updateChartHeight());
            $scope.$on("$destroy", () => resizeSub.unsubscribe());

            $scope.redrawChart = function() {
                if ($scope.chart.activeChart) {
                    $scope.chartData = $scope.chart.activeChart.data();
                }
            };

            var savedChartType = $scope.$storage.greeksWidget.chartType || 'netDelta';
            // Force chart type to be net delta if the user doesn't have advanced delta feature
            if (!userConfig.features['EXTENSION_DELTA_ANALYSIS_ADV']) {
                savedChartType = 'netDelta';
            }

            // Data fix old data where possible
            if (savedChartType === 'net') {
                savedChartType = 'netDelta'
            }

            $scope.setActiveChart(chartMap[savedChartType] || netDeltaChart);


            $scope.$on('gridster-resized', function() {
                $scope.updateChartHeight();
            });

            $scope.$on('gridster-item-resized-stop', function(widget) {
                $scope.updateChartHeight();
            });

            $scope.$watch('gridsterItem.sizeY', function() {
                $scope.updateChartHeight();
            });

            // TODO probably remove this as it breaks on other greeks
            $scope.emitFilterEvent = function() {
                $scope.$emit('position.table.preset', {
                    filterColumn : 'security',
                    filterTerm : $scope.chart.security,
                    sortColumn : 'netDelta',
                    ascending : true
                });
            };

            $scope.updateChartHeight = function() {
                if (!$scope.chartOptions) {
                    return;
                }

                if($scope.gridsterItem != null) {
                    $scope.widgetContentHeight = $scope.calculateAvailableWidgetHeight($scope.gridsterItem);
                }
                $scope.chartOptions.chart.height = $scope.widgetContentHeight;

                if (chartApi != null) {
                    chartApi.refresh();
                }
            };

            $scope.toggleIncludeEquities = function() {
                $scope.$storage.greeksWidget.includeEquities = !$scope.$storage.greeksWidget.includeEquities;
                $scope.chart.includeEquities = $scope.$storage.greeksWidget.includeEquities;
                $scope.redrawChart();
            };

            function createChartOptions(chart) {
                return {
                    chart: {
                        type: 'multiBarHorizontalChart',
                        height: $scope.widgetContentHeight,
                        margin: {
                            top: 10,
                            right: 30,
                            bottom: 50,
                            left: 60
                        },
                        multibar: {
                            dispatch: {
                                elementClick: function (event) {
                                    $scope.chart.security = event.data[2];
                                    $scope.updateChart();
                                    $scope.emitFilterEvent();
                                }
                            }
                        },
                        x: function (d) {
                            return d[0];
                        },
                        y: function (d) {
                            return d[1];
                        },
                        showControls: false,
                        showValues: true,
                        duration: 1000,
                        stacked: true,
                        useInteractiveGuideline: true,
                        xAxis: {
                            showMaxMin: false,
                            highlightZero: false

                        },
                        yAxis: {
                            axisLabel: chart.yAxisLabel,
                            tickFormat: chart.tickFormat
                        },
                        tooltip: {
                            contentGenerator : function(e) {
                                if ($scope.chart.activeChart) {
                                    return $scope.chart.activeChart.tooltip(e);
                                }
                            }
                        }
                    }
                }
            }

            $scope.$on('margin.whatif.changed', function(event, newWhatIfMargin){ updateData(newWhatIfMargin); });

            if($scope.lastMarginWhatifChangedData && $scope.lastMarginWhatifChangedData.whatIfMargin) {
                updateData($scope.lastMarginWhatifChangedData.whatIfMargin)
            }

            function updateData(newWhatIfMargin) {
                whatIfMargin = newWhatIfMargin;
                $timeout(function () {
                    $scope.updateChart();
                }, 100);
            }

        }]);
}
